export const modalStyles = `
  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  .modern-input {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px 14px;
    transition: all 0.2s;
  }
  .modern-input:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
  }
  .modern-select {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px 14px;
    transition: all 0.2s;
  }
  .modern-select:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
  }
  .edital-card {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 16px;
    transition: all 0.2s;
  }
  .edital-card:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  .modern-checkbox {
    width: 18px;
    height: 18px;
    border-radius: 4px;
  }
  .add-btn {
    border: 2px dashed #0d6efd;
    background: transparent;
    color: #0d6efd;
    border-radius: 8px;
    padding: 10px;
    transition: all 0.2s;
  }
  .add-btn:hover {
    background: #f0f7ff;
    border-color: #0a58ca;
  }
  .remove-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dc3545;
    background: transparent;
    color: #dc3545;
    transition: all 0.2s;
  }
  .remove-btn:hover {
    background: #dc3545;
    color: white;
  }
`;
